import React from 'react';
import styled from 'styled-components';
import ApplyPckgProdImg from '../common/image/ApplyPckgProdImg';
import CountInputBtn from '../common/button/CountInputBtn';
import SpanPckgNavPrice from '../common/price/SpanPckgNavPrice';
import NormalSmallBtn from '../common/button/NormalSmallBtn';
import CustomImg from '../common/image/CustomImg';
import {isMobileOnly} from 'react-device-detect';
import { find, remove, findIndex} from 'lodash';
import { useSelector, useDispatch } from 'react-redux';
import CheckBtn from '../common/button/CheckBtn';
import { setCartCheckInfoAction, cart_check_info } from '../../modules/su/userProdModule';

const SrMyCartItemTrBlock = styled.tr`

    .pointer {
        cursor: pointer;
    }
`;
const MobileSrMyCartItemBlock = styled.div`
    padding: 23px 0 10px;
      /* display:flex;
      flex-direction: column;
      padding-bottom:1rem;
      border-bottom: 1px solid #ccc;
      margin-bottom:1rem;
      
      .info {
        display: flex;                
       
        .name-container {
          display: flex;
          flex-direction: column;
          justify-content: space-around;
          width: 60vw;
          margin-left:1rem;
       
          .name, .option {
            text-overflow: ellipsis;            
            white-space: nowrap;
            overflow: hidden;          
          }
        }      
      }
      .control {
        display: flex;
        justify-content: space-between;
      } */
      .pointer {
        cursor: pointer;
    }
`;

const MobileSrMyCartItemInfoBlock = styled.div`
      height: 98px;
`;

const MobileSrMyCartItemNameContainerBlock = styled.div`
      float: left;
      width: calc(88vw - 160px);

      .price {
        font-size: 12px;
        font-weight: normal;
        font-stretch: normal;
        font-style: normal;
        line-height: 1.4;
        color: #999999;
        text-decoration: line-through; 
        margin-bottom: 4px;
    }
    
    .sale {
        font-size: 12px;
        font-weight: 500;
        font-stretch: normal;
        font-style: normal;
        line-height: 1.2;
        color: #333333;
        margin-right: 10px;
    }
`;

const MobileSrMyCartItemNameBlock = styled.div`
    font-size: 14px;
    font-weight: normal;
    line-height: 1.43;
    letter-spacing: normal;
    text-align: left;
    color: #333333;
    margin-bottom: 10px;

    max-height: 42px;
    display: -webkit-box;
    word-wrap: break-word;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    -o-text-overflow: ellipsis;
    text-overflow: ellipsis;
`;

const MobileSrMyCartItemOptionBlock = styled.div`
    font-size: 12px;
    font-weight: normal;
    line-height: 1.4;
    letter-spacing: normal;
    text-align: left;
    color: #666666;
    margin-bottom: 8px;
`;

const MobileSrMyCartItemControlBlock = styled.div`
    margin-top: 10px;
    position: relative;
    padding-right: 20px;
`;

const SrMyCartItemTdBlock = styled.td`

    padding: 17px 0 17px 10px;
    vertical-align: ${props => props.vAlign || 'middle'};
    border-bottom: 1px solid #ccc;
    line-height: 1.5;
    position: relative;
    font-size: 15px;
    text-align: ${props => props.align || 'left'};

    .price {
        font-size: 12px;
        font-weight: normal;
        font-stretch: normal;
        font-style: normal;
        line-height: 1.4;
        color: #999999;
        text-decoration: line-through; 
        margin-bottom: 4px;
    }
    
    .sale {
        font-size: 14px;
        font-weight: 500;
        font-stretch: normal;
        font-style: normal;
        line-height: 1.2;
        color: #333333;
    }
`;

const SrMyCartItemTdTitleBlock = styled.p`
    display: -webkit-box;
    height: 42px;
    font-size: 14px;
    word-wrap: break-word;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    -o-text-overflow: ellipsis;
    text-overflow: ellipsis;
`;

const SrMyCartItemTdOptionBlock = styled.div`
    position: absolute;
    bottom: 20px;
    color: #666;
    font-size: 14px;
`;

const SrMyCartItemBrandTdBlock = styled.td`
    background-color: #f4f4f4;
    border-right: 1px solid #ccc;
    border-top: 1px solid #ccc;
    text-align: center;
    vertical-align: middle;
`;

const SrMyCartItemSoldOutBlock = styled.span`
    //color: #f00;
    margin-right : 8px;
`;

const SrMyCartItemDimPBlock = styled.div`
    position: absolute;
    top: 20px;
    width: 100px;
    height: 100px;
    overflow: hidden;
    //border-radius: 4px;
    background-color: rgba(255,255,255,0.7);
    pointer-events: none;
`;

const SrMyCartItemFinishSpanBlock = styled.span`
    display: inline-block;
    position: relative;
    line-height: 24px;
    padding: 0 10px;
    color: #fff;
    border-radius: 12px;
    font-size: 13px;
    margin: 1px auto 1px;
    //width : 42px;
    height : 24px;
    font-family: 'Noto Sans CJK KR';
    border: 1px solid #666;
    font-weight: 400;
    margin-right: 8px;
    background-color: #666666;
`;

const SrMyCartItemDeleteBlock = styled.button`
    ${isMobileOnly?`
    float: right;  
    margin-right: -8px;
    margin-top: -11px;
    `:`
    ''
    `};
    width: 36px;
    height: 36px;
    background: url(/assets/images/icon/btn_delete.png) center center/auto no-repeat;
`;

const SrMyCartItemTr = ({ item, idx, rowspan, removeRow, updateCnt, reqEs, disabled }) => {
    const dispatch = useDispatch();

    const { accessToken, prodCartSoldInfo, prodCartCheckInfo } = useSelector(
        ({ userReducer, userProdReducer }) => ({
            accessToken: userReducer.accessToken,
            prodCartSoldInfo: userProdReducer.prodCartSoldInfo,
            prodCartCheckInfo: userProdReducer.prodCartCheckInfo,
        })
    );

    const changeValueHandler = (value) => {
        updateCnt(item.prdct_id, item.opt_id, value);

        let idx = findIndex(prodCartCheckInfo, (curitem) => {
            return curitem.prdct_id === item.prdct_id;
        })

        if(idx >= 0) {
            let checkInfo = [];
            Object.assign(checkInfo, prodCartCheckInfo);
            checkInfo[idx].qty = value;
            dispatch(setCartCheckInfoAction(checkInfo));
        }

    }

    // 상품 삭제 버튼
    const handleDelClick = () => {
        removeRow(idx);
    }

    // 요청하기 클릭
    const handleEsReqClik = () => {
        !disabled && reqEs();
    }

    const getSoldOutInfo = () => {
        if(accessToken !== null) {
            //console.log("item = " + JSON.stringify(item));
            if(item !== null && item.sell_status !== '020102') {
                return "품절";
            }
            else if(item !== null && item.opt_id > 0 && item.opt_status < 1){
                return "품절";
            }
        }

        if(prodCartSoldInfo !== null && prodCartSoldInfo.length > 0){
            let info = find(prodCartSoldInfo, (curitem) => {
                return curitem.prdct_id === item.prdct_id && curitem.opt_id === item.opt_id;
            });

            //console.log("info = " + JSON.stringify(info));
            if(info !== undefined && info !== null && info.sell_status !== undefined && info.sell_status !== null && info.sell_status !== '020102') {
                return "품절";
            }
            else if(info !== undefined && info !== null && info.opt_id !== undefined && info.opt_id !== null && info.opt_id > 0 && info.opt_status < 1){
                return "품절";
            }
        }

        return '';
    }

    const getSellStatusSolodOutInfo = () => {
        if(accessToken !== null) {
            if(item !== null && item.sell_status !== '020102') {
                return true;
            }
        }

        if(prodCartSoldInfo !== null && prodCartSoldInfo.length > 0){
            let info = find(prodCartSoldInfo, (curitem) => {
                return curitem.prdct_id === item.prdct_id && curitem.opt_id === item.opt_id;
            });

            if(info !== undefined && info !== null && info.sell_status !== undefined && info.sell_status !== null && info.sell_status !== '020102') {
                return true;
            }
        }

        return false;
    }

    const getBrandTdArea = () => {

        if (idx !== 0) return;

        return (

            <SrMyCartItemBrandTdBlock rowSpan={rowspan}>
                <CustomImg width="102px" height="28px"
                    marginBottom="20px"
                    img_src={item.brnd_logo_url} />
                <br></br>
                <NormalSmallBtn text='견적 요청하기' width='120px' height='40px'
                    lineHeight='38px' borderRadius='20px'
                    fontSize='15px' fontWeight='300'
                    float='initial' onClick={handleEsReqClik}
                    bgColor={disabled?'#e0e0e0':'#ffc742'}
                    textColor={disabled?'#bbb':'#111'}
                />

            </SrMyCartItemBrandTdBlock>

        )
    }

    const isOptionDisp = () => {
        if (item.opt_nm === null || item.opt_nm === '' ||
            item.opt_nm === item.prdct_nm) {
            return 'none';
        } else {
            return 'block';
        }
    }

    const goToProduct = () => {
        if(getSoldOutInfo().length === 0) {
            //history.push("/prod?prodid=" + item.prdct_id);
            let url = "/prod?prodid=" + item.prdct_id;
            var win = window.open(url, '_blank');
            win.focus();
        }
        
    }

    const handleCheckClick = (value) => {

        if (value) {
            let checkInfo = [];
            Object.assign(checkInfo, prodCartCheckInfo);
            let info = {};
            Object.assign(info, cart_check_info)
            info.brnd_id = item.brnd_id;
            info.prdct_id = item.prdct_id;
            info.qty = item.qty;
            info.es_opt_pirce = item.es_opt_pirce;
            info.prdct_price = item.prdct_price;
            if(item.prdct_price === item.sale_price) {
                info.prdct_price = item.es_opt_pirce;
            }
            info.opt_id = item.opt_id;
            if(getSoldOutInfo().length > 0 ) {
                info.isSoldOut = true;
            } else {
                info.isSoldOut = false;
            }
            checkInfo.push(info);
            dispatch(setCartCheckInfoAction(checkInfo));
            //console.log("checkInfo = " + JSON.stringify(checkInfo))
        } else {
            let checkInfo = [];
            Object.assign(checkInfo, prodCartCheckInfo);
            remove(checkInfo, (obj) => {
                return (obj.prdct_id === item.prdct_id && obj.opt_id === item.opt_id);
            })
            dispatch(setCartCheckInfoAction(checkInfo));
            //console.log("checkInfo del = " + JSON.stringify(checkInfo))
        }
    }

    // 체크 상태 확인
    const getCheckStatus = () => {

        let idx = findIndex(prodCartCheckInfo, (curitem) => {
            return (curitem.prdct_id === item.prdct_id && curitem.opt_id === item.opt_id);
        })
        return (idx >= 0);
    }

    const handleCheckClickSoldOut = (value) => {

    }

    // 체크 상태 확인
    const getCheckStatusSoldOut = () => {
        let idx = findIndex(prodCartCheckInfo, (curitem) => {
            return (curitem.prdct_id === item.prdct_id && curitem.opt_id === item.opt_id);
        })

        if(idx >= 0) {
            let checkInfo = [];
            Object.assign(checkInfo, prodCartCheckInfo);
            remove(checkInfo, (obj) => {
                return (obj.prdct_id === item.prdct_id && obj.opt_id === item.opt_id);
            })
            dispatch(setCartCheckInfoAction(checkInfo));
        }

        return false;
    }

    if(getSoldOutInfo().length > 0 ) {
        return (
            isMobileOnly? //mobile
              <MobileSrMyCartItemBlock>
                  <MobileSrMyCartItemInfoBlock className="clearfix">
                <div style={{float: 'left', marginRight:'3px'}}><CheckBtn defaultValue={getCheckStatusSoldOut()} disable={true}/> </div>
                <div style={{float: 'left', marginRight:'10px', width:'98px'}}>
                    <ApplyPckgProdImg img={item.img}
                                id={item.prdct_id}
                                onDelClick={handleDelClick}
                                noShowDelBtn={true} width={"98px"}
                                isShowWDim={true}
                                isLinkNo={getSellStatusSolodOutInfo()===true ? true:false}/>
                </div>
                <MobileSrMyCartItemNameContainerBlock>
                {getSellStatusSolodOutInfo()===true ? <div style={{float:'left'}}>
                      <SrMyCartItemFinishSpanBlock>품절</SrMyCartItemFinishSpanBlock>
                      </div>:''}
                    <MobileSrMyCartItemNameBlock style={getSellStatusSolodOutInfo()===true ? {color:'#bbbbbb', lineHeight: '26px'}:{color:'#bbbbbb'}}>{item.prdct_nm}</MobileSrMyCartItemNameBlock>
                    <MobileSrMyCartItemOptionBlock style={{color:'#bbbbbb'}}>
                    {"(품절) "}{item.opt_nm}
                    </MobileSrMyCartItemOptionBlock>
                    <div>
                    <p className="sale f-left">{Number(item.es_opt_pirce.toFixed(1)).toLocaleString()}</p>
                    {
                        item.sale_price === item.prdct_price ? '' :
                        <p className="price f-left">{Number(item.prdct_price.toFixed(1)).toLocaleString()}</p>
                    }
                    </div>
                </MobileSrMyCartItemNameContainerBlock>
                <SrMyCartItemDeleteBlock onClick={handleDelClick}/>
            </MobileSrMyCartItemInfoBlock>
            <MobileSrMyCartItemControlBlock className="clearfix" style={{color:'#bbbbbb'}}>
                <div style={{marginLeft: '34px', position: 'absolute' }}>
                    <CountInputBtn
                    changeValueHandler={changeValueHandler}
                    num={item.qty}
                    width="32px" height="28px" isDisable={true}/>
                </div>
                <div style={{float: 'right', paddingTop: '12px'}}>
                    <SpanPckgNavPrice value={item.es_prdct_price}
                    fontSize='14px' fontWeight='600' wonFontSize='14px' float='none' isDisable='true'/>
                </div>  
            </MobileSrMyCartItemControlBlock>

{/* 
                  <div className="info">
                    <ApplyPckgProdImg img={item.img}
                                      id={item.prdct_id}
                                      onDelClick={handleDelClick}
                                      alwaysShowDelBtn={true}
                                      isShowWDim={true}
                                      isLinkNo={getSellStatusSolodOutInfo()===true ? true:false}/>
                    <div className="name-container">
                    {getSellStatusSolodOutInfo()===true ? <div style={{float:'left'}}>
                      <SrMyCartItemFinishSpanBlock>품절</SrMyCartItemFinishSpanBlock>
                      </div>:''}
                      <span className="name" style={getSellStatusSolodOutInfo()===true ? {color:'#bbbbbb'} : {}}>
                          {item.prdct_nm}</span>
                      <div className="option" style={{color:'#bbbbbb'}}>
                        {"(품절) "}
                          {item.opt_nm}</div>
                    </div>
                  </div>
                  <div className="control" style={{color:'#bbbbbb'}}>
                    <CountInputBtn
                      changeValueHandler={changeValueHandler}
                      num={item.qty}
                      width="33px" height="30px" isDisable={true}/>
                    <SpanPckgNavPrice value={item.es_prdct_price}
                                      fontSize='20px' fontWeight='700' float='none' />
                  </div> */}
      
      
              </MobileSrMyCartItemBlock>
              : //desktop
              <SrMyCartItemTrBlock>
                  {
                      //getBrandTdArea()
                      <SrMyCartItemTdBlock style={{ width: '67px', paddingLeft:'41px' }}>
                        <CheckBtn defaultValue={getCheckStatusSoldOut()} disable={true}/>
                      </SrMyCartItemTdBlock>
                  }
                  <SrMyCartItemTdBlock style={{ width: '112px', paddingLeft:'12px' }} >
      
                      <ApplyPckgProdImg img={item.img}
                          id={item.prdct_id}
                          onDelClick={handleDelClick} 
                          isShowWDim={true}
                          noShowDelBtn={true}
                          isLinkNo={getSellStatusSolodOutInfo()===true ? true:false}/>
                  </SrMyCartItemTdBlock>
      
                  <SrMyCartItemTdBlock vAlign={"top"} style={{ width: '376px', paddingLeft:'17px' }}>
                      {getSellStatusSolodOutInfo()===true ? <div style={{float:'left'}}>
                      <SrMyCartItemFinishSpanBlock>품절</SrMyCartItemFinishSpanBlock>
                      </div>:''}
                      
                      <div>
                      <SrMyCartItemTdTitleBlock style={getSellStatusSolodOutInfo()===true ? {color:'#bbbbbb', lineHeight: '26px'}:{color:'#bbbbbb'} }>
                          {item.prdct_nm}
                      </SrMyCartItemTdTitleBlock>
                      </div>
                      
                      <SrMyCartItemTdOptionBlock style={{ display: isOptionDisp(), color:'#bbbbbb' }}>
                          <p>{
                          <SrMyCartItemSoldOutBlock>{"(품절)"}</SrMyCartItemSoldOutBlock>}
                              <span>{item.opt_nm}</span></p>
                      </SrMyCartItemTdOptionBlock>
                  </SrMyCartItemTdBlock>
      
                  <SrMyCartItemTdBlock align={'center'} style={{ width: '240px',paddingLeft:'30px', paddingRight:'30px'}}>
                    {
                        item.sale_price === item.prdct_price ? '' :
                        <p className="price">{Number(item.prdct_price.toFixed(1)).toLocaleString()}</p>
                    }
                    <p className="sale">{Number(item.es_opt_pirce.toFixed(1)).toLocaleString()}</p>
                    
                </SrMyCartItemTdBlock>

                  <SrMyCartItemTdBlock style={{ width: '131px',paddingLeft:'0px', paddingRight:'0px'}}>
                      <CountInputBtn
                          changeValueHandler={changeValueHandler}
                          num={item.qty}
                          width="40px" height="36px" 
                          isDisable={true}/>
                  </SrMyCartItemTdBlock>
      
                  <SrMyCartItemTdBlock align='center' style={{ width: '193px', paddingRight:'20px', textAlign:'right', color:'#bbbbbb'}}>
                      <SpanPckgNavPrice value={item.es_prdct_price}
                          fontSize='20px' fontWeight='500' float='none' isDisable='true'/>
                  </SrMyCartItemTdBlock>

                  <SrMyCartItemTdBlock align='center' style={{ width: '50px',paddingLeft:'0px', paddingRight:'14px'}}>
                    <SrMyCartItemDeleteBlock onClick={handleDelClick}/>
                </SrMyCartItemTdBlock>
              </SrMyCartItemTrBlock>
          ); 
    }

    return (
      isMobileOnly? //mobile
        <MobileSrMyCartItemBlock>
            <MobileSrMyCartItemInfoBlock className="clearfix">
                <div style={{float: 'left', marginRight:'3px'}}><CheckBtn onClick={handleCheckClick} defaultValue={getCheckStatus()}/> </div>
                <div style={{float: 'left', marginRight:'10px', width:'98px'}}>
                    <ApplyPckgProdImg img={item.img}
                                id={item.prdct_id}
                                onDelClick={handleDelClick}
                                noShowDelBtn={true} width={"98px"}/>
                </div>
                <MobileSrMyCartItemNameContainerBlock>
                    <MobileSrMyCartItemNameBlock onClick={goToProduct} className="pointer">{item.prdct_nm}</MobileSrMyCartItemNameBlock>
                    <MobileSrMyCartItemOptionBlock onClick={goToProduct} className="pointer">
                    {getSoldOutInfo().length > 0 ?
                    <SrMyCartItemSoldOutBlock>{getSoldOutInfo()}</SrMyCartItemSoldOutBlock>:''}
                    {item.opt_nm}
                    </MobileSrMyCartItemOptionBlock>
                    <div>
                    <p className="sale f-left">{Number(item.es_opt_pirce.toFixed(1)).toLocaleString()}</p>
                    {
                        item.sale_price === item.prdct_price ? '' :
                        <p className="price f-left">{Number(item.prdct_price.toFixed(1)).toLocaleString()}</p>
                    }
                    </div>
                </MobileSrMyCartItemNameContainerBlock>
                <SrMyCartItemDeleteBlock onClick={handleDelClick}/>
            </MobileSrMyCartItemInfoBlock>
            <MobileSrMyCartItemControlBlock className="clearfix">
                <div style={{marginLeft: '34px', position: 'absolute'}}>
                    <CountInputBtn
                    changeValueHandler={changeValueHandler}
                    num={item.qty}
                    width="32px" height="28px" />
                </div>
                <div style={{float: 'right', paddingTop: '12px'}}>
                    <SpanPckgNavPrice value={item.es_prdct_price}
                    fontSize='14px' fontWeight='500' wonFontSize='14px' float='none' />
                </div>  
                {/* <div style={{float: 'right', marginRight: '8px', paddingTop: '14px'}}>
                {
                        item.sale_price === item.prdct_price ? '' :
                        <SpanPckgNavPrice value={item.prdct_price*1*item.qty} fontSize='12px' fontWeight='500' wonFontSize='12px' float='none' isSale={true}/>
                }
                </div>  */}
            </MobileSrMyCartItemControlBlock>
            {/* <div className="info">
                <CheckBtn onClick={handleCheckClick} defaultValue={getCheckStatus()}/>
                <ApplyPckgProdImg img={item.img}
                                id={item.prdct_id}
                                onDelClick={handleDelClick}
                                noShowDelBtn={true}/>
              <div className="name-container">
                <div className="name">{item.prdct_nm}</div>
                <div className="option">
                    {getSoldOutInfo().length > 0 ?
                    <SrMyCartItemSoldOutBlock>{getSoldOutInfo()}</SrMyCartItemSoldOutBlock>:''}
                    {item.opt_nm}</div>
              </div>
              <SrMyCartItemDeleteBlock onClick={handleDelClick}/>
            </div>
            <div className="control">
              <CountInputBtn
                changeValueHandler={changeValueHandler}
                num={item.qty}
                width="33px" height="30px" />
              <SpanPckgNavPrice value={item.es_prdct_price}
                                fontSize='20px' fontWeight='700' float='none' />
            </div> */}


        </MobileSrMyCartItemBlock>
        : //desktop
        <SrMyCartItemTrBlock>
            {
                //getBrandTdArea()
                <SrMyCartItemTdBlock style={{ width: '67px', paddingLeft:'41px' }} >
                    <CheckBtn onClick={handleCheckClick} defaultValue={getCheckStatus()}/>
                </SrMyCartItemTdBlock>
            }
            <SrMyCartItemTdBlock style={{ width: '112px', paddingLeft:'12px' }} >

                <ApplyPckgProdImg img={item.img}
                    id={item.prdct_id}
                    noShowDelBtn={true}
                    onDelClick={handleDelClick} />

            </SrMyCartItemTdBlock>

            <SrMyCartItemTdBlock vAlign={'top'} style={{ width: '376px', paddingLeft:'17px' }}>
                <SrMyCartItemTdTitleBlock onClick={goToProduct} className="pointer">
                    {item.prdct_nm}
                </SrMyCartItemTdTitleBlock>
                <SrMyCartItemTdOptionBlock style={{ display: isOptionDisp() }}>
                    <p>{getSoldOutInfo().length > 0 ?
                    <SrMyCartItemSoldOutBlock>{getSoldOutInfo()}</SrMyCartItemSoldOutBlock>:''}
                        <span onClick={goToProduct} className="pointer">{item.opt_nm}</span></p>
                </SrMyCartItemTdOptionBlock>
            </SrMyCartItemTdBlock>

            <SrMyCartItemTdBlock align={'center'} style={{ width: '240px',paddingLeft:'30px', paddingRight:'30px'}}>
                    {
                        item.sale_price === item.prdct_price ? '' :
                        <p className="price">{Number(item.prdct_price.toFixed(1)).toLocaleString()}</p>
                    }
                    <p className="sale">{Number(item.es_opt_pirce.toFixed(1)).toLocaleString()}</p>
                    
            </SrMyCartItemTdBlock>

            <SrMyCartItemTdBlock style={{ width: '131px',paddingLeft:'0px', paddingRight:'0px'}}>
                <CountInputBtn
                    changeValueHandler={changeValueHandler}
                    num={item.qty}
                    width="40px" height="36px" />
            </SrMyCartItemTdBlock>

            <SrMyCartItemTdBlock align='center'style={{ width: '193px', paddingRight:'13.5px', textAlign:'right'}}>
                <SpanPckgNavPrice value={item.es_prdct_price}
                    fontSize='20px' fontWeight='500' float='none' />
                   {/*  {
                        item.sale_price === item.prdct_price ? '' :
                        <SpanPckgNavPrice value={item.prdct_price*1*item.qty} fontSize='14px' fontWeight='500' wonFontSize='14px' float='none' isSale={true}/>
                    } */}
                    
            </SrMyCartItemTdBlock>

            <SrMyCartItemTdBlock align='center' style={{ width: '50px',paddingLeft:'0px', paddingRight:'14px'}}>
                <SrMyCartItemDeleteBlock onClick={handleDelClick}/>
            </SrMyCartItemTdBlock>
        </SrMyCartItemTrBlock>
    );
};

export default SrMyCartItemTr;
